import axios from 'axios';
import { getHeaders, SECRET_FOR_INIT, FUNLIDAY_HOST_URL } from '../apis/main';

/** fetchfunlidayInit 初始化拿 funliday server 的資料
 * @returns {Promise} axiosPromise
 */
export const fetchfunlidayInit = yahoo => {
  const body = {
    secretId: SECRET_FOR_INIT,
  };
  if (yahoo === 'yahoo') body.source = yahoo;
  const headers = {
    ...getHeaders(true),
  };
  return axios.post(`${FUNLIDAY_HOST_URL}init`, body, { headers });
};

export const fetchTwitterInit = () => {
  const body = {};
  const headers = {
    ...getHeaders(),
  };
  return axios.post(`${FUNLIDAY_HOST_URL}initForTwitter`, body, { headers });
};
